import { render, staticRenderFns } from "./UpdateOtherCost.vue?vue&type=template&id=d23d17e4"
import script from "./UpdateOtherCost.vue?vue&type=script&lang=js"
export * from "./UpdateOtherCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports